import { routeConstants } from "constants/routeConstants";
import { Country } from "country-state-city";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "slice";
import { updateNewJobData } from "slice/jobs";
import { validations } from "utils/validations";

export const useJobLocation = () => {
    const [applicationsFrom, setApplicationsFrom] = useState("selectCountry");
    const [projectLocation, setProjectLocation] = useState({
        country: "United Arab Emirates",
        city: "",
    });
    const [projectLocationErrors, setProjectLocationErrors] = useState({
        country: "",
        city: "",
    });
    const [countryCode, setCountryCode] = useState<string>("AE");
    const [applicationCountry, setApplicationCountry] = useState<string[]>([
        "",
    ]);
    const [applicationCountryError, setApplicationCountryError] = useState("");
    const { user, jobs } = useAppSelector((state) => state);

    const isEdit = jobs.newJobData?.isEdit;

    const navigateTo = useNavigate();
    const dispatch = useDispatch();

    const { id: job_id } = useParams();

    const handleProjectLocationChange = (
        name: "country" | "city",
        value: string
    ) => {
        setProjectLocation((prev) => ({
            ...prev,
            [name]: value,
        }));

        setProjectLocationErrors((prev) => ({
            ...prev,
            [name]: validations(name, value),
        }));
    };

    const handleChangeAppFrom = (val: string) => {
        setApplicationsFrom(val);
    };

    const handleApplicationCountryChange = (value: any) => {
        setApplicationCountry([value]);
    };

    const handleBack = () => {
        if (isEdit) {
            navigateTo(
                routeConstants.jobs.editAJob.root +
                    `${jobs.newJobData?.id}/` +
                    routeConstants.jobs.editAJob.purpose
            );
        } else
            navigateTo(
                routeConstants.jobs.postAJob.root +
                    routeConstants.jobs.postAJob.purpose
            );
    };

    const handleNext = () => {
        const locationErrors = {
            city: validations(
                "city",
                projectLocation.city === "Select City"
                    ? ""
                    : projectLocation.city
            ),
            country: validations("country", projectLocation.country),
        };
        let applicationCountryError = "";
        setProjectLocationErrors(locationErrors);
        if (applicationsFrom === "selectCountry") {
            if (applicationCountry[0].length === 0) {
                applicationCountryError = "Please select an option.";
                setApplicationCountryError(applicationCountryError);
            }
        }

        if (
            locationErrors.city === "" &&
            locationErrors.country === "" &&
            applicationCountryError === ""
        ) {
            dispatch(
                updateNewJobData({
                    ...jobs.newJobData,
                    job_location: {
                        city: projectLocation.city,
                        country_name: projectLocation.country,
                        application_from: applicationsFrom,
                        application_from_country_names: applicationCountry,
                    },
                })
            );

            if (isEdit) {
                navigateTo(
                    routeConstants.jobs.editAJob.root +
                        `${jobs.newJobData?.id}/` +
                        routeConstants.jobs.editAJob.details
                );
            } else
                navigateTo(
                    routeConstants.jobs.postAJob.root +
                        routeConstants.jobs.postAJob.details
                );
        }
    };

    useEffect(() => {
        if (!jobs.newJobData?.job_purpose || !jobs.newJobData.job_category) {
            if (job_id) {
                navigateTo(
                    routeConstants.jobs.editAJob.root +
                        routeConstants.jobs.postAJob.category +
                        job_id
                );
            } else
                navigateTo(
                    routeConstants.jobs.postAJob.root +
                        routeConstants.jobs.postAJob.category
                );
        }
    }, [job_id, jobs, navigateTo]);

    useEffect(() => {
        if (jobs.newJobData?.job_location) {
            const data = jobs.newJobData?.job_location;
            setApplicationsFrom(
                data.application_from === null ||
                    data.application_from === "selectCountry"
                    ? "selectCountry"
                    : "worldwide"
            );
            setApplicationCountry(data.application_from_country_names);
            setProjectLocation({
                city: data.city,
                country: data.country_name || "",
            });
            setCountryCode(
                Country.getAllCountries().filter(
                    (val) => val.name === data.country_name
                )[0]?.isoCode
            );
        }
    }, [jobs.newJobData?.job_location]);

    return {
        applicationsFrom,
        handleChangeAppFrom,
        projectLocation,
        projectLocationErrors,
        applicationCountry,
        applicationCountryError,
        handleBack,
        handleNext,
        handleProjectLocationChange,
        handleApplicationCountryChange,
        agencyName: user.agency?.name ?? "agency",
        purposeName: jobs.newJobData?.job_purpose?.name ?? "purpose",
        countryCode,
        setCountryCode,
    };
};
